export const SURVEY_HANDLE = 'survey-uninstall'

export const SURVEY_TYPE = {
  MAIN: 'mainSurvey',
  SUB: 'subSurvey',
}
